import React from 'react';
import Card from './Card';

const UserCard = ({base_url}) => {
  const fields = ['role', 'created_date', 'full_name', 'user_name', 'password_hash', 'phone_number', 'address', 'age'];
  const endpoint = `${base_url}/users`;
  return <Card endpoint={endpoint} fields={fields} />;
};

export default UserCard;